// Microsoft (Azure / Entra ID) sign-in — "link-only" model.
//
// Microsoft is an ALTERNATIVE door into an account that already exists
// (created via the school wizard or an admin invite). It never provisions
// access on its own: an unknown Microsoft account lands on /auth/callback
// with no role in user_metadata and is refused there.
//
// Requires (Supabase dashboard, one-time): the Azure provider enabled with the
// Entra app's client ID/secret, "Link identities by email" ON (so a Microsoft
// sign-in resolves to the SAME user as the invited email/password account),
// and `<origin>/auth/callback` in the Redirect URLs allow-list.
import { supabase } from './supabase';
import { isDemoMode } from './demo/store';

/** Which login page the person started from — used only to tailor the
 *  callback's messaging. Routing is decided by user_metadata.role, never this. */
export type MsIntent = 'school' | 'teacher';

/**
 * Kick off the Microsoft OAuth redirect. On success the browser navigates
 * away to Microsoft, so this only returns when it FAILS to start.
 */
export async function signInWithMicrosoft(intent: MsIntent): Promise<{ error: string | null }> {
  // Never touch the real OAuth flow from inside the demo.
  if (isDemoMode()) return { error: null };

  const redirectTo = `${window.location.origin}/auth/callback?intent=${intent}`;
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'azure',
    options: {
      redirectTo,
      scopes: 'email openid profile',
    },
  });
  return { error: error ? error.message : null };
}
